export function signInRequest(email, password) {
  return {
    type: '@auth/SIGN_IN_REQUEST',
    payload: { email, password },
  };
}

export function signInSuccess(token, user) {
  return {
    type: '@auth/SIGN_IN_SUCCESS',
    payload: { token, user },
  };
}

export function signUpRequest(name, email, emailConfirm, password, passwordConfirm) {
  return {
    type: '@auth/SIGN_UP_REQUEST',
    payload: { name, email, emailConfirm, password, passwordConfirm },
  };
}

export function signFailure() {
  return {
    type: '@auth/SIGN_FAILURE',
  };
}

export function authStartLoading() {
  return {
    type: '@auth/LOADING_START',
  };
}

export function authEndLoading() {
  return {
    type: '@auth/LOADING_END',
  };
}

export function signOut() {
  return {
    type: '@auth/SIGN_OUT',
  };
}
